import { FunctionComponent, useState } from "react";
import { DismissableHtmlNotice } from "@pjs/core-ui";
import { useOnValueChange } from "@pjs/react-utilities";
import { actionLogger } from "@pjs/a11y";
import { IStateNotice } from "./interfaces/IStateNotice";
import { ISettingsViewNoticesProps } from "./interfaces/ISettingsViewNoticesProps";
import "@pjs/a11y/dist/styles/utilities.css";

export const SettingsViewNotices: FunctionComponent<ISettingsViewNoticesProps> = (props) => {
    const [currentNotice, setCurrentNotice] = useState<IStateNotice | null>(null);

    const onDismissNotice = (): void => {
        setCurrentNotice(null);

        props.onNoticeDismiss();
    };

    useOnValueChange(
        () => {
            if (props.noticeObservable === null) {
                return;
            }

            const noticeSub = props.noticeObservable.subscribe((newNotice) => {
                setCurrentNotice(newNotice);
                actionLogger.append(newNotice.actionLogMessage);
            });

            return () => {
                noticeSub.unsubscribe();
            };
        },
        [props.noticeObservable],
        true
    );

    return (
        <div className={currentNotice === null ? "util-hide-element" : ""}>
            {currentNotice !== null && (
                <DismissableHtmlNotice
                    type={currentNotice.type}
                    ariaLabel={currentNotice.ariaLabel}
                    content={currentNotice.message}
                    onDismiss={onDismissNotice}
                />
            )}
        </div>
    );
};
